<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div
    class="text-sm rounded-xl outline outline-1 outline-n-container shadow-sm"
  >
    <button
      type="button"
      class="flex items-center select-none w-full m-0 cursor-grab justify-between gap-2 py-2.5 px-3 drag-handle transition-colors"
      :class="
        isOpen
          ? 'bg-n-solid-2 border-b border-n-weak'
          : 'bg-n-slate-2 hover:bg-n-slate-3'
      "
      @click.stop="onToggle"
    >
      <div class="flex items-center min-w-0 gap-2">
        <EmojiOrIcon class="inline-block w-5 flex-shrink-0" :icon="icon" :emoji="emoji" />
        <h5 class="text-n-slate-12 text-sm font-semibold mb-0 truncate">
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center gap-1 flex-shrink-0">
        <slot name="button" />
        <span
          class="flex items-center justify-center size-7 rounded-md bg-n-alpha-black2 text-n-blue-11"
        >
          <span
            class="i-lucide-chevron-down text-base transition-transform duration-200"
            :class="{ 'rotate-180': isOpen }"
          />
        </span>
      </div>
    </button>
    <div
      v-if="isOpen"
      class="bg-n-surface-1 overflow-visible"
      :class="compact ? 'p-0' : 'p-3'"
    >
      <slot />
    </div>
  </div>
</template>
